import { Context, Effect } from "effect";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { WorkerBindingsSnapshot } from "./model.ts";

export interface WorkerBindingsApiShape {
  readonly load: (workspaceId: string) => Effect.Effect<WorkerBindingsSnapshot, ResourceFailure>;
}
export class WorkerBindingsApi extends Context.Service<WorkerBindingsApi, WorkerBindingsApiShape>()("workerstation/frontend/WorkerBindingsApi") {}
